import { Check, Minus } from "lucide-react";
import { fmt } from "@/lib/api";

export function packagePrice(c, p, promo) {
  const free = p.free || [];
  const feats = c.features.filter((f) => p.features.includes(f.name) && !free.includes(f.name)).reduce((s, f) => s + f.price, 0);
  return (promo ? c.promo_base_price : c.base_price) + Math.max(0, p.pages - c.included_pages) * c.page_price + feats;
}

const Cell = ({ p, name }) => {
  if (!p.features.includes(name)) return <Minus size={14} className="mx-auto text-[#171715]/25" />;
  if (p.free?.includes(name)) return <span className="text-[11px] font-semibold text-[#3d7a37]">Pulsuz</span>;
  return <Check size={16} strokeWidth={2.5} className="mx-auto text-[#b58a3f]" />;
};

export default function PackageCompare({ c, promo, active, onPick }) {
  const list = c.packages || [];
  if (list.length < 2) return null;
  const col = (p) => `${active === p.name ? "bg-[#FBF6EC]" : p.popular ? "bg-[#171715]/[.03]" : ""}`;
  return (
    <div className="mb-8 -mt-3 rounded-xl border border-[#171715]/10 bg-white" data-testid="calc-compare">
      <table className="w-full table-fixed text-[11px] sm:text-sm">
        <thead>
          <tr className="border-b border-[#171715]/10">
            <th className="text-left p-2 sm:p-3 w-[34%] sm:w-auto text-[10px] sm:text-xs font-medium text-[#77736B]">Müqayisə</th>
            {list.map((p, i) => (
              <th key={p.name} className={`p-1.5 sm:p-3 text-center font-display font-semibold leading-tight break-words ${col(p)}`} data-testid={`calc-compare-head-${i}`}>{p.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-[#171715]/5">
            <td className="p-2 sm:p-3 text-[#77736B]">Səhifə sayı</td>
            {list.map((p) => <td key={p.name} className={`p-1.5 sm:p-3 text-center font-semibold ${col(p)}`}>{p.pages}</td>)}
          </tr>
          {list.some((p) => p.duration) && (
            <tr className="border-b border-[#171715]/5">
              <td className="p-2 sm:p-3 text-[#77736B]">Hazır olma müddəti</td>
              {list.map((p) => <td key={p.name} className={`p-1.5 sm:p-3 text-center text-xs font-semibold ${col(p)}`}>{p.duration || "—"}</td>)}
            </tr>
          )}
          {c.features.map((f) => (
            <tr key={f.name} className="border-b border-[#171715]/5">
              <td className="p-2 sm:p-3 text-[#2d2c29]">{f.name}</td>
              {list.map((p) => <td key={p.name} className={`p-1.5 sm:p-3 text-center ${col(p)}`}><Cell p={p} name={f.name} /></td>)}
            </tr>
          ))}
          <tr>
            <td className="p-2 sm:p-3 font-semibold">Qiymət</td>
            {list.map((p, i) => (
              <td key={p.name} className={`p-1.5 sm:p-3 text-center ${col(p)}`}>
                <p className="font-display font-bold text-xs sm:text-base whitespace-nowrap" data-testid={`calc-compare-price-${i}`}>{fmt(packagePrice(c, p, promo))} ₼</p>
                <button type="button" onClick={() => active !== p.name && onPick(p)} className={`mt-2 text-[10px] sm:text-xs font-semibold rounded-full px-2 sm:px-3 py-1 ${active === p.name ? "bg-[#171715] text-[#F3D592]" : "border border-[#171715]/20 hover:bg-[#171715] hover:text-[#F3D592]"}`} data-testid={`calc-compare-pick-${i}`}>
                  {active === p.name ? "Seçilib" : "Seç"}
                </button>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
